import { RouteName } from "../RouteNames";

// Routing can sometimes cause invalid routes, redirect gracefully
export const lobbiesRoutes = {
  name: RouteName.LobbiesRoot,
  path: "lobbies",
  redirect: () => ({ name: RouteName.Lobbies }),
  children: [
    {
      path: "",
      name: RouteName.Lobbies,
      component: () =>
        import("@follaw-fr/views/side_menu_views/LobbiesView.vue"),
    },
    { path: "activities", redirect: { name: RouteName.LobbiesRoot } },
    { path: "news", redirect: { name: RouteName.LobbiesRoot } },

    {
      name: RouteName.LobbiesFollawedRoot,
      path: "follawed",
      component: () =>
        import("@follaw-fr/views/side_menu_views/LobbiesView.vue"),
      children: [
        {
          name: RouteName.LobbiesFollawed,
          path: "",
          component: () =>
            import("@follaw-fr/components/lobbies/organisms/LobbiesDatas.vue"),
        },
        {
          name: RouteName.LobbiesFollawedNews,
          path: "news",
          component: () => import("@follaw-fr/views/lobbies/LobbyNews.vue"),
        },
        {
          name: RouteName.LobbiesFollawedActivities,
          path: "activities",
          component: () =>
            import("@follaw-fr/views/lobbies/LobbyActivities.vue"),
          children: [
            {
              name: "Lobbies Follawed Activités - Default",
              path: "",
              redirect: {
                name: "Lobbies Follawed - Lobbying",
              },
            },
            {
              name: RouteName.LobbiesFollawedActivitiesLobbying,
              path: "lobbying",
              component: () =>
                import("@follaw-fr/views/lobbies/LobbyActivitiesLobbying.vue"),
            },
            {
              name: RouteName.LobbiesFollawedActivitiesPublications,
              path: "publications",
              component: () =>
                import(
                  "@follaw-fr/views/lobbies/LobbyActivitiesPublications.vue"
                ),
            },
          ],
        },
      ],
    },

    {
      name: RouteName.LobbiesZoomRoot,
      path: ":_id",
      component: () =>
        import("@follaw-fr/views/side_menu_views/LobbyZoomView.vue"),
      children: [
        {
          name: RouteName.LobbiesZoom,
          path: "",
          component: () =>
            import("@follaw-fr/views/lobbies/LobbyZoomGeneral.vue"),
        },
        {
          name: RouteName.LobbiesZoomNews,
          path: "news",
          component: () => import("@follaw-fr/views/lobbies/LobbyNews.vue"),
        },
        {
          name: RouteName.LobbiesZoomActivitiesRoot,
          path: "activities",
          component: () =>
            import("@follaw-fr/views/lobbies/LobbyActivities.vue"),
          children: [
            {
              name: RouteName.LobbiesZoomActivities,
              path: "",
              redirect: {
                name: "Lobby Activités - Lobbying",
              },
            },
            {
              name: RouteName.LobbiesZoomActivitiesLobbying,
              path: "lobbying",
              component: () =>
                import("@follaw-fr/views/lobbies/LobbyActivitiesLobbying.vue"),
            },
            {
              name: RouteName.LobbiesZoomActivityPublications,
              path: "publications",
              component: () =>
                import(
                  "@follaw-fr/views/lobbies/LobbyActivitiesPublications.vue"
                ),
            },
          ],
        },
        {
          name: RouteName.LobbiesZoomClient,
          path: "clients",
          component: () =>
            import("@follaw-fr/views/lobbies/LobbyZoomClients.vue"),
        },
        {
          name: RouteName.LobbiesZoomStaff,
          path: "staff",
          component: () =>
            import("@follaw-fr/views/lobbies/LobbyZoomStaff.vue"),
        },
      ],
    },
    {
      name: RouteName.LobbiesZoomQuestion,
      path: ":_id/question/:questionId",
      component: () =>
        import("@follaw-fr/views/side_menu_views/LobbyQuestionZoomView.vue"),
    },
    {
      name: RouteName.LobbiesZoomReport,
      path: ":_id/comptes-rendus/:docRef",
      component: () =>
        import("@follaw-fr/views/side_menu_views/LobbyReportCrZoomView.vue"),
    },
  ],
};
